"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncounterProcedureList_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EncounterProcedureListProcedure_1 = require("./EncounterProcedureListProcedure");
var ProcedureList_1 = require("./ProcedureList");
var EncounterProcedureList_Factory = /** @class */ (function () {
    function EncounterProcedureList_Factory() {
    }
    EncounterProcedureList_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EncounterProcedureListProcedures: model.EncounterProcedureListProcedures && model.EncounterProcedureListProcedures.map(function (i) { return EncounterProcedureListProcedure_1.EncounterProcedureListProcedure_Factory.CreateIncoming(i); }),
            IsDefaultForProcedureList: model.IsDefaultForProcedureList,
            Name: model.Name,
            ProcedureList: ProcedureList_1.ProcedureList_Factory.CreateIncoming(model.ProcedureList),
            ProcedureListId: model.ProcedureListId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    EncounterProcedureList_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EncounterProcedureListProcedures: model.EncounterProcedureListProcedures && model.EncounterProcedureListProcedures.map(function (i) { return EncounterProcedureListProcedure_1.EncounterProcedureListProcedure_Factory.CreateOutgoing(i); }),
            IsDefaultForProcedureList: model.IsDefaultForProcedureList,
            Name: model.Name,
            ProcedureList: ProcedureList_1.ProcedureList_Factory.CreateOutgoing(model.ProcedureList),
            ProcedureListId: model.ProcedureListId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return EncounterProcedureList_Factory;
}());
exports.EncounterProcedureList_Factory = EncounterProcedureList_Factory;
